import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 21l1 -5l-1 -4l-3 -4h4l3 -3","key":"svg-0"}],["path",{"d":"M6 16l-1 -4l3 -4","key":"svg-1"}],["path",{"d":"M5 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M13.5 12h2.5l4 2","key":"svg-3"}]]

const IconFall = createReactComponent('outline', 'fall', 'Fall', __iconNode);

export default IconFall;